import React from "react";
import millify from "millify";
import { Typography, Row, Col,Statistic,Avatar } from "antd";
import { Link } from "react-router-dom";
import {useGetCryptosQuery} from "../services/cryptoApi";
import{Cryptocurrencies} from "../components";
import {News} from "../components";
import Loader from './Loader';
import icon from "../images/icons8-miner-100.png"



const {Title}  = Typography;

const Homepage = () => {
    const {data, isFetching} = useGetCryptosQuery(10);
    const globalStats = data?.data?.stats;

    if (isFetching) return <Loader/>;

    return(
        <>
            
            <Title level={1} className="heading" style={{textAlign: "left", fontSize: "50px", marginTop: "150px"}}>
                Welcome to Cryptopedia 
                <Avatar src={icon} size="large" style={{width: "100px", height: "100px", marginLeft: "3rem"}}/>
                <br/>
                A place for cryptocurrency enthusiasts!
            </Title>
            <Title level={2} className="heading" style={{textAlign: "center", marginRight: "10rem"}}>Global Crypto</Title>
            <Row style={{textAlign: "center",padding: "0",margin: "0",color: "white"}}>
                <Col span={5} ><Statistic title="Total Cryptocurrencies" value={globalStats.total} /></Col>
                <Col span={5} ><Statistic title="Total Exchanges" value={millify(globalStats.totalExchanges)} /></Col>
                <Col span={5} ><Statistic title="Total Market cap" value={millify(globalStats.totalMarketCap)}/></Col>
                <Col span={5} ><Statistic title="Total 24h volume" value={millify(globalStats.total24hVolume)} /></Col>
                <Col span={4} ><Statistic title="Total Markets" value={millify(globalStats.totalMarkets)} /></Col>
            </Row>
             <div className="home-heading-container">
                <Title level={2} className="home-title"> Most popular Cryptocurrencies</Title>
                <Title level={3} className='show-more'><Link to='/cryptocurrencies' style={{color: "#FABB51"}}> Show all</Link></Title>
            </div>
            <Cryptocurrencies simplified/> 
            <div className="home-heading-container">
                <Title level={2} className="home-title">Latest news</Title>
                <Title level={3} className='show-more'><Link to='/news' style={{color: "#FABB51"}}>See more</Link></Title>
            </div>
            <News simplified/> 
        </>
    )
}

export default Homepage